/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Routes } from '@angular/router';

import {AppListComponent} from './applist-component/applist.component';
import {ApplicationComponent} from './application-component/application.component';


export const ROUTES: Routes = [
    { path: '',      component: AppListComponent },
    { path: 'applications/:id', component: ApplicationComponent },
    { path: 'applications', component: ApplicationComponent },
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/selector/app.routes.ts